/**
 * Использовать при крайней необходимости.
 * Можно заменить готовыми хелперами из utils/errors.
 *
 * Возвращает `true`, если ошибка была выброшена axios
 * @param error Ошибка от сервиса
 */
export function isAxiosError(error) {
    return Boolean(error.isAxiosError);
}
